/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import {getActiveBranchId} from '../utils/branch';
import React,{useState,useEffect,useCallback} from 'react';
import Layout from '../components/layout/Layout';
import {useNavigate} from 'react-router-dom';
import StatCard from '../components/common/StatCard';
import SlidePanel from '../components/common/SlidePanel';
import DataTable from '../components/common/DataTable';
import Badge from '../components/common/Badge';
import {Input,Select} from '../components/common/FormField';
import api from '../services/api';
import PatientSearchInput from '../components/patient/PatientSearchInput';
import {fmtDate,fmtDateTime} from '../utils/helpers';
import AdmissionSearchInput from '../components/common/AdmissionSearchInput';

function mfilter<T>(items: T[], query: string, fields: string[]): T[] {
  if (!query) return items;
  const q = query.toLowerCase();
  return items.filter((item:any) =>
    fields.some(f => {
      const val = f.split('.').reduce((o: any, k) => o?.[k], item);
      return val != null && String(val).toLowerCase().includes(q);
    })
  );
}


const MODALITIES=['XRAY','CT','MRI','USG','MAMMOGRAPHY','ECG','ECHO','TMT','PET_CT'];
const MODALITY_ICON:Record<string,string>={XRAY:'🩻',CT:'🔬',MRI:'🧲',USG:'🔊',ECG:'📈',ECHO:'❤️',TMT:'🏃',MAMMOGRAPHY:'🩷',PET_CT:'⚛️'};
const PRIORITIES=['ROUTINE','URGENT','STAT'];
const CRITICAL_TYPES=['BRAIN_HEMORRHAGE','PNEUMOTHORAX','STROKE','MASSIVE_PE','AORTIC_DISSECTION','TENSION_PNEUMOTHORAX','FRACTURE_SPINE','CARDIAC_TAMPONADE','OTHER'];
const STATUS_CSS:Record<string,string>={
  ORDERED:'bg-blue-100 text-[#02357A]',SCHEDULED:'bg-teal-100 text-teal-700',
  IN_PROGRESS:'bg-amber-100 text-amber-700',STUDY_DONE:'bg-purple-100 text-purple-700',
  REPORTED:'bg-indigo-100 text-indigo-700',COMPLETED:'bg-green-100 text-green-700',
  CANCELLED:'bg-red-100 text-red-700',TELERADIOLOGY:'bg-cyan-100 text-cyan-700',
};
const REPORT_STATUS_CSS:Record<string,string>={DRAFT:'bg-slate-100 text-slate-600',VERIFIED:'bg-blue-100 text-[#02357A]',DELIVERED:'bg-green-100 text-green-700',AMENDED:'bg-amber-100 text-amber-700'};
const fmt=(v:any)=>parseFloat(v||0).toLocaleString('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});

export default function RadiologyPage(){
  const nav=useNavigate();
  const [page,setPage]=useState(1);
  const PAGE_SIZE=20;
  const [tab,setTab]=useState<string>('dashboard');
  const [stats,setStats]=useState<any>({});
  const [loading,setLoading]=useState(false);
  const [msg,setMsg]=useState('');
  const [saving,setSaving]=useState(false);

  const [services,setServices]=useState<any[]>([]);
  const [rooms,setRooms]=useState<any[]>([]);
  const [doctors,setDoctors]=useState<any[]>([]);
  const [templates,setTemplates]=useState<any[]>([]);
  const [orders,setOrders]=useState<any[]>([]);
  const [orderFilter,setOrderFilter]=useState('');
  const [modalityFilter,setModalityFilter]=useState('');
  const [schedules,setSchedules]=useState<any[]>([]);
  const [schedDate,setSchedDate]=useState(new Date().toISOString().split('T')[0]);
  const [pendingReports,setPendingReports]=useState<any[]>([]);
  const [criticalAlerts,setCriticalAlerts]=useState<any[]>([]);
  const [teleItems,setTeleItems]=useState<any[]>([]);
  const [reportData,setReportData]=useState<any>(null);
  const [reportDates,setRD]=useState({from:new Date(Date.now()-30*86400000).toISOString().split('T')[0],to:new Date().toISOString().split('T')[0],
      contrastUsed:false,
      contrastAgent:'',
      contrastDose:'',
      patientWeight:'',
      creatinine:'',
      gfrLevel:'',
      reportedBy:'',
      verifiedBy:'',
      radiologistId:'',
      seriesUid:'',
      instanceNumber:'',
      dicomUid:'',
      machineId:'',
      technician:'',
      radiationDose:'',
      kvp:'',
      mas:'',
      sliceThickness:'',
      otherCharges:'',
      gstCgst:'',
      gstSgst:'',
      insuranceClaimNumber:'',
      billedBy:'',
      checkinBy:'',
      printHistory:'',
      teleradiologistEmail:'',
      studyLink:''
    });

  // Order form
  const [showOrderForm,setShowOrderForm]=useState(false);
  const [orderPatient,setOrderPatient]=useState<any>(null);
  const [orderForm,setOrderForm]=useState<any>({serviceId:'',modality:'XRAY',bodyPart:'',priority:'ROUTINE',clinicalNotes:'',indication:'',source:'OPD',contrastRequired:false,admissionId:'',visitId:''});
  const [svcSearch,setSvcSearch]=useState('');

  // Selected order for workflow

  // Schedule form

  // Checkin form

  // Study form

  // Report form

  // Service master form
  const [showSvcForm,setShowSvcForm]=useState(false);
  const [svcForm,setSvcForm]=useState({serviceCode:'',serviceName:'',modality:'XRAY',bodyPart:'',contrastRequired:false,standardDurationMinutes:'30',tatHours:'4',basePrice:'',contrastPrice:'0',reportingPrice:'',filmCharges:'0'});

  // Template form
  const [showTplForm,setShowTplForm]=useState(false);
  const [tplForm,setTplForm]=useState({templateCode:'',templateName:'',modality:'XRAY',bodyPart:'',techniqueTemplate:'',findingsTemplate:'',impressionTemplate:''});

  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  useEffect(()=>{
    api.getRadiologyStats().then(r=>setStats(r.data||{})).catch(()=>{});
    api.getRadiologyServices().then(r=>setServices(r.data||[])).catch(()=>{});
    api.getRadiologyRooms().then(r=>setRooms(r.data||[])).catch(()=>{});
    api.getDoctors().then(r=>setDoctors(r.data||[])).catch(()=>{});
    api.getRadiologyTemplates().then(r=>setTemplates(r.data||[])).catch(()=>{});
  },[]);

  const loadTab=useCallback(async()=>{
    setLoading(true);
    try{
      if(tab==='dashboard'||tab==='orders'){const r=await api.getRadiologyOrders({status:orderFilter||undefined,modality:modalityFilter||undefined,take:50});setOrders(r.data?.data||[]);}
      if(tab==='schedule'){const r=await api.getRadiologySchedules({date:schedDate});setSchedules(r.data||[]);}
      if(tab==='worklist'){const r=await api.getRadiologyOrders({status:'STUDY_DONE',take:50});setPendingReports(r.data?.data||[]);}
      if(tab==='alerts'){const r=await api.getCriticalAlerts();setCriticalAlerts(r.data||[]);}
      if(tab==='tele'){const r=await api.getTeleradiologyCases();setTeleItems(r.data||[]);}
      if(tab==='reports'){const r=await api.getRadiologyReport2(reportDates);setReportData(r.data);}
    }catch{}finally{setLoading(false);}
  },[tab,orderFilter,modalityFilter,schedDate,reportDates]);
  useEffect(()=>{const t=setTimeout(loadTab,300);return()=>clearTimeout(t);},[loadTab]);

  const openWorkflow=(order:any)=>{
    nav(`/radiology/order/${order.id}`);
  };

  const submitOrder=async(e:React.FormEvent)=>{
    e.preventDefault();if(!orderPatient)return;setSaving(true);
    const svc=services.find((s:any)=>s.id===orderForm.serviceId);
    try{await api.createRadiologyOrder({...orderForm,branchId:getActiveBranchId()||undefined,patientId:orderPatient.id,patientName:`${orderPatient.firstName} ${orderPatient.lastName||''}`,modality:svc?.modality||orderForm.modality,contrastRequired:svc?.contrastRequired||orderForm.contrastRequired});notify('✅ Order created!');setShowOrderForm(false);setOrderPatient(null);setOrderForm({serviceId:'',modality:'XRAY',bodyPart:'',priority:'ROUTINE',clinicalNotes:'',indication:'',source:'OPD',contrastRequired:false,admissionId:'',visitId:''});loadTab();}
    catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}finally{setSaving(false);}
  };

                    const submitSvc=async(e:React.FormEvent)=>{e.preventDefault();setSaving(true);try{await api.createRadiologyService(svcForm);notify('✅ Service added!');setShowSvcForm(false);api.getRadiologyServices().then(r=>setServices(r.data||[])).catch(()=>{});}catch(e:any){notify('❌ '+e.response?.data?.message);}finally{setSaving(false);}};
  const submitTpl=async(e:React.FormEvent)=>{e.preventDefault();setSaving(true);try{await api.createRadiologyTemplate(tplForm);notify('✅ Template added!');setShowTplForm(false);api.getRadiologyTemplates().then(r=>setTemplates(r.data||[])).catch(()=>{});}catch(e:any){notify('❌ '+e.response?.data?.message);}finally{setSaving(false);}};

  const WORKFLOW_STEPS=[['info','ℹ️'],['schedule','📅'],['checkin','✅'],['study','🖼️'],['report','📝'],['billing','💰']];
  const TABS=[['dashboard','🏥 Dashboard'],['orders','📋 Orders'],['schedule','📅 Schedule'],['worklist','📝 Worklist'],['alerts','🚨 Critical Alerts'],['tele','🌐 Teleradiology'],['services','⚙️ Services'],['templates','📄 Templates'],['reports','📊 Reports'],['new_order','➕ New Order']];

  return(
    <Layout title="Radiology — RIS/PACS" actions={
      <div className="flex gap-2">
        {tab==='orders'&&<button onClick={()=>setTab('new_order')} className="btn-primary text-sm">+ New Order</button>}
        {tab==='services'&&<button onClick={()=>setShowSvcForm(true)} className="btn-secondary text-sm">+ Service</button>}
        {tab==='templates'&&<button onClick={()=>setShowTplForm(true)} className="btn-secondary text-sm">+ Template</button>}
        {tab==='schedule'&&<div className="flex gap-1"><button onClick={()=>setSchedDate(d=>{const nd=new Date(d);nd.setDate(nd.getDate()-1);return nd.toISOString().split('T')[0];})} className="btn-secondary px-2">◀</button><input type="date" className="input !w-36 text-sm" value={schedDate} onChange={e=>setSchedDate(e.target.value)}/><button onClick={()=>setSchedDate(d=>{const nd=new Date(d);nd.setDate(nd.getDate()+1);return nd.toISOString().split('T')[0];})} className="btn-secondary px-2">▶</button></div>}
      </div>
    }>
      {msg&&<div className={`mb-3 p-2.5 rounded-lg text-sm border ${msg.startsWith('✅')?'bg-green-50 text-green-700 border-green-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}
      {criticalAlerts.length>0&&<div className="mb-4 p-3 bg-red-600 text-white rounded-xl flex items-center justify-between"><p className="font-bold text-sm">🚨 {criticalAlerts.length} Critical Alert{criticalAlerts.length>1?'s':''} Pending</p><button onClick={()=>setTab('alerts')} className="text-xs border border-white/50 rounded px-2 py-1 hover:bg-white/20">View Alerts →</button></div>}

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-5">
        <StatCard label="Today's Orders" value={stats.todayOrders||0} icon="📋" color="blue"/>
        <StatCard label="Pending" value={stats.pending||0} icon="⏳" color="amber"/>
        <StatCard label="In Progress" value={stats.inProgress||0} icon="🔬" color="purple"/>
        <StatCard label="Pending Reports" value={stats.pendingReports||0} icon="📝" color="amber"/>
        <StatCard label="Critical Unread" value={stats.criticalUnread||0} icon="🚨" color="red"/>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 overflow-x-auto pb-1 border-b">
        {TABS.map(([t,l])=><button key={t} onClick={()=>setTab(t as any)} className={`px-3 py-2 rounded-t-lg text-xs font-medium whitespace-nowrap flex-shrink-0 ${tab===t?'bg-[#02357A] text-white':'text-slate-600 hover:bg-slate-100'}${t==='alerts'&&criticalAlerts.length?' ring-2 ring-red-500':''}`}>{l}</button>)}
      </div>

      {/* DASHBOARD */}
      {tab==='dashboard'&&(
        <div className="space-y-5">
          {/* Modality rooms */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {rooms.filter((r:any)=>r.isActive).map((r:any)=>(
              <div key={r.id} className={`card p-3 border-2 text-center ${r.status==='AVAILABLE'?'border-green-300 bg-green-50':r.status==='IN_USE'?'border-red-300 bg-red-50':'border-amber-200 bg-amber-50'}`}>
                <p className="text-2xl">{MODALITY_ICON[r.modality]||'🏥'}</p>
                <p className="font-bold text-sm mt-1">{r.roomCode}</p>
                <p className="text-xs text-slate-400">{r.roomName}</p>
                <span className={`text-xs font-semibold ${r.status==='AVAILABLE'?'text-green-600':r.status==='IN_USE'?'text-red-600':'text-amber-600'}`}>{r.status}</span>
              </div>
            ))}
          </div>
          {/* Today's orders */}
          <div className="card overflow-hidden">
            <div className="p-4 border-b flex justify-between items-center"><h3 className="font-semibold text-slate-700">Active Orders</h3><button onClick={()=>setTab('orders')} className="text-xs text-[#02357A] hover:underline">View All →</button></div>
            <div className="divide-y max-h-80 overflow-y-auto">
              {orders.filter((o:any)=>!['COMPLETED','CANCELLED'].includes(o.status)).slice(0,10).map((o:any)=>(
                <div key={o.id} className="p-3 flex items-center justify-between cursor-pointer hover:bg-slate-50" onClick={()=>openWorkflow(o)}>
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">{MODALITY_ICON[o.modality]||'🏥'}</span>
                    <div><p className="font-medium text-sm">{o.modality} — {o.patient_first_name||''} {o.patient_last_name||''} <span className="text-xs text-slate-400">{o.uhid||''}</span></p><p className="text-xs text-slate-400">{o.order_number||o.orderNumber} · {o.priority}</p></div>
                  </div>
                  <div className="flex items-center gap-2">
                    {o.contrastRequired&&<span className="text-xs bg-blue-50 text-[#02357A] px-1.5 rounded border">Contrast</span>}
                    <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_CSS[o.status]||'bg-slate-100 text-slate-500'}`}>{o.status?.replace('_',' ')}</span>
                  </div>
                </div>
              ))}
              {orders.filter((o:any)=>!['COMPLETED','CANCELLED'].includes(o.status)).length===0&&<p className="p-6 text-sm text-slate-400 text-center">No active orders</p>}
            </div>
          </div>
        </div>
      )}

      {/* ORDERS */}
      {tab==='orders'&&(
        <div className="space-y-3">
          <div className="flex gap-2 flex-wrap">
            {['','ORDERED','SCHEDULED','IN_PROGRESS','STUDY_DONE','COMPLETED','CANCELLED'].map(s=><button key={s} onClick={()=>setOrderFilter(s)} className={`text-xs px-3 py-1.5 rounded-full border font-medium ${orderFilter===s?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300 text-slate-600 hover:bg-slate-50'}`}>{s||'All'}</button>)}
            <Select value={modalityFilter} onChange={e=>setModalityFilter(e.target.value)} className="!w-28 text-xs !py-1"><option value="">All Modality</option>{MODALITIES.map(m=><option key={m}>{m}</option>)}</Select>
          </div>
          <div className="card overflow-hidden">
            <DataTable loading={loading} emptyMessage="No radiology orders" emptyIcon="🩻" data={orders} columns={[
              {key:'no',label:'Order #',render:(r:any)=><span className="font-mono text-xs">{r.order_number||r.orderNumber}</span>},
              {key:'modal',label:'Modality',render:(r:any)=><div className="flex items-center gap-1"><span>{MODALITY_ICON[r.modality]||'🏥'}</span><Badge label={r.modality} className="bg-slate-100 text-slate-700"/></div>},
              {key:'service',label:'Service',render:(r:any)=><p className="text-sm text-slate-600 line-clamp-1">{services.find((s:any)=>s.id===r.serviceId)?.serviceName||r.modality}</p>},
              {key:'patient',label:'Patient',render:(r:any)=><span className="text-xs text-slate-500">{r.patient_first_name||''} {r.patient_last_name||''}</span>},
              {key:'priority',label:'Priority',render:(r:any)=><Badge label={r.priority||'ROUTINE'} className={r.priority==='STAT'?'bg-red-100 text-red-700':r.priority==='URGENT'?'bg-amber-100 text-amber-700':'bg-slate-100 text-slate-600'}/>},
              {key:'contrast',label:'Contrast',render:(r:any)=>r.contrastRequired?<span className="text-xs text-[#02357A] font-semibold">Yes</span>:<span className="text-slate-300 text-xs">—</span>},
              {key:'date',label:'Ordered',render:(r:any)=><span className="text-xs text-slate-400">{fmtDate(r.created_at||r.createdAt)}</span>},
              {key:'status',label:'Status',render:(r:any)=><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_CSS[r.status]||''}`}>{r.status?.replace('_',' ')}</span>},
              {key:'actions',label:'',render:(r:any)=><button onClick={()=>openWorkflow(r)} className="text-xs text-[#02357A] hover:underline font-medium">Open →</button>},
            ]}/>
          </div>
        </div>
      )}

      {/* SCHEDULE */}
      {tab==='schedule'&&(
        <div className="space-y-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {rooms.filter((r:any)=>r.isActive).map((room:any)=>(
              <div key={room.id} className="card overflow-hidden">
                <div className="p-2 bg-slate-50 border-b text-center"><p className="font-bold text-sm">{MODALITY_ICON[room.modality]||'🏥'} {room.roomCode}</p><p className="text-xs text-slate-400">{room.roomName}</p></div>
                <div className="p-2 max-h-64 overflow-y-auto">
                  {schedules.filter((s:any)=>s.roomId===room.id).map((s:any)=>(
                    <div key={s.id} className="text-xs p-1.5 mb-1 bg-blue-50 rounded border border-blue-200">
                      <p className="font-semibold text-[#02357A]">{new Date(s.scheduledStart).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',hour12:true})}</p>
                      <p className="text-slate-500 truncate">Pt: {s.patientId?.slice(-6)||'—'}</p>
                      <Badge label={s.status} className="mt-0.5 text-xs"/>
                    </div>
                  ))}
                  {!schedules.filter((s:any)=>s.roomId===room.id).length&&<p className="text-xs text-slate-300 text-center py-3">Free</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* WORKLIST (pending reports) */}
      {tab==='worklist'&&(
        <div className="card overflow-hidden">
          <DataTable loading={loading} emptyMessage="No studies awaiting report" emptyIcon="📝" data={pendingReports} columns={[
            {key:'no',label:'Order #',render:(r:any)=><span className="font-mono text-xs">{r.order_number||r.orderNumber}</span>},
            {key:'modal',label:'Modality',render:(r:any)=><span>{MODALITY_ICON[r.modality]||'🏥'} {r.modality}</span>},
            {key:'patient',label:'Patient',render:(r:any)=><span className="text-xs">{r.patient_first_name||''} {r.patient_last_name||''}</span>},
            {key:'tat',label:'TAT',render:(r:any)=>{const hrs=Math.abs((Date.now()-new Date(r.created_at||r.createdAt).getTime())/3600000);return<span className={`text-xs font-semibold ${hrs>4?'text-red-600':hrs>2?'text-amber-600':'text-green-600'}`}>{hrs.toFixed(1)}h</span>;}},
            {key:'priority',label:'Priority',render:(r:any)=><Badge label={r.priority||'ROUTINE'} className={r.priority==='STAT'?'bg-red-100 text-red-700':r.priority==='URGENT'?'bg-amber-100 text-amber-700':'bg-slate-100 text-slate-600'}/>},
            {key:'actions',label:'',render:(r:any)=><button onClick={()=>nav(`/radiology/order/${r.id}?step=report`)} className="text-xs text-[#02357A] hover:underline font-medium">Report →</button>},
          ]}/>
        </div>
      )}

      {/* CRITICAL ALERTS */}
      {tab==='alerts'&&(
        <div className="space-y-2">
          {criticalAlerts.length===0&&<div className="card p-8 text-center text-slate-400"><p className="text-4xl mb-2">✅</p><p>No critical alerts</p></div>}
          {criticalAlerts.map((a:any)=>(
            <div key={a.id} className={`p-4 rounded-xl border-l-4 ${a.isResolved?'bg-slate-50 border-slate-300':'bg-red-50 border-red-600'}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    {!a.isResolved&&<span className="text-xs bg-red-600 text-white px-2 py-0.5 rounded font-bold animate-pulse">CRITICAL</span>}
                    <span className="font-bold text-sm">{a.alertType?.replace(/_/g,' ')}</span>
                    <span className="text-xs text-slate-400">{fmtDateTime(a.alertedAt)}</span>
                  </div>
                  <p className="text-sm text-slate-700">{a.finding}</p>
                  <p className="text-xs text-slate-400 mt-1">Patient: {a.patientId} · Order: {a.orderId?.slice(-8)}</p>
                </div>
                {!a.isResolved&&<button onClick={async()=>{const action=prompt('Action taken:');if(action){await api.ackCriticalAlert(a.id,{actionTaken:action});notify('✅ Alert acknowledged!');loadTab();}}} className="ml-3 flex-shrink-0 text-xs border border-red-300 rounded-lg px-3 py-1.5 text-red-700 hover:bg-red-100 font-medium">Acknowledge</button>}
                {a.isResolved&&<div className="text-xs text-green-600 font-semibold ml-3 flex-shrink-0">✅ Resolved<br/>{a.actionTaken}</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* TELERADIOLOGY */}
      {tab==='tele'&&(
        <div className="card overflow-hidden">
          <DataTable loading={loading} emptyMessage="No teleradiology cases" emptyIcon="🌐" data={teleItems} columns={[
            {key:'no',label:'Case #',render:(r:any)=><span className="font-mono text-xs">{r.caseNumber}</span>},
            {key:'center',label:'Reporting Center',render:(r:any)=><div><p className="font-medium">{r.reportingCenter}</p><p className="text-xs text-slate-400">{r.radiologistName||'—'}</p></div>},
            {key:'sent',label:'Sent At',render:(r:any)=><span className="text-xs">{fmtDateTime(r.sentAt)}</span>},
            {key:'priority',label:'Priority',render:(r:any)=><Badge label={r.priority} className={r.priority==='STAT'?'bg-red-100 text-red-700':'bg-slate-100 text-slate-600'}/>},
            {key:'status',label:'Status',render:(r:any)=><Badge label={r.status} status={r.status}/>},
            {key:'received',label:'Report Received',render:(r:any)=>r.reportReceivedAt?<span className="text-xs text-green-600">{fmtDateTime(r.reportReceivedAt)}</span>:<span className="text-slate-300 text-xs">Pending</span>},
            {key:'actions',label:'',render:(r:any)=>r.status!=='REPORT_RECEIVED'&&<button onClick={async()=>{await api.updateTeleradiology(r.id,{status:'REPORT_RECEIVED'});notify('✅ Report received!');loadTab();}} className="text-xs text-green-600 hover:underline">Mark Received</button>},
          ]}/>
        </div>
      )}

      {/* SERVICES */}
      {tab==='services'&&(
        <div className="card overflow-hidden">
          <DataTable loading={loading} emptyMessage="No services" emptyIcon="⚙️" data={services} columns={[
            {key:'code',label:'Code',render:(r:any)=><span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded">{r.service_code||r.serviceCode}</span>},
            {key:'name',label:'Service',render:(r:any)=><p className="font-medium">{r.service_name||r.serviceName}</p>},
            {key:'modal',label:'Modality',render:(r:any)=><Badge label={r.modality} className="bg-blue-50 text-[#02357A]"/>},
            {key:'body',label:'Body Part',render:(r:any)=><span className="text-xs text-slate-500">{r.bodyPart||'—'}</span>},
            {key:'tat',label:'TAT',render:(r:any)=><span className="text-xs">{r.tatHours}h</span>},
            {key:'dur',label:'Duration',render:(r:any)=><span className="text-xs">{r.standardDurationMinutes}min</span>},
            {key:'contrast',label:'Contrast',render:(r:any)=>r.contrastRequired?<span className="text-xs text-[#02357A] font-semibold">Yes</span>:<span className="text-slate-300 text-xs">—</span>},
            {key:'price',label:'Base Price',render:(r:any)=><span className="font-semibold">{fmt(r.base_price||r.basePrice)}</span>},
            {key:'total',label:'Total',render:(r:any)=><span className="text-sm text-green-600 font-bold">{fmt(+r.base_price||r.basePrice+(+r.contrastPrice||0)+(+r.reportingPrice||0)+(+r.filmCharges||0))}</span>},
          ]}/>
        </div>
      )}

      {/* TEMPLATES */}
      {tab==='templates'&&(
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {templates.map((t:any)=>(
            <div key={t.id} className="card p-4">
              <div className="flex justify-between items-start mb-2">
                <div><p className="font-semibold">{t.templateName}</p><p className="text-xs text-slate-400">{t.modality} · {t.bodyPart||'—'} · <span className="font-mono">{t.templateCode}</span></p></div>
                <Badge label={t.modality} className="bg-blue-50 text-[#02357A] flex-shrink-0"/>
              </div>
              <p className="text-xs text-slate-500 line-clamp-2 bg-slate-50 p-2 rounded">{t.findingsTemplate}</p>
              <p className="text-xs text-[#02357A] mt-1 font-medium line-clamp-1">{t.impressionTemplate}</p>
            </div>
          ))}
        </div>
      )}

      {/* REPORTS */}
      {tab==='reports'&&(
        <div className="space-y-5">
          <div className="card p-4 flex gap-3 items-end flex-wrap">
            <div><label className="label">From</label><Input type="date" value={reportDates.from} onChange={e=>setRD({...reportDates,from:e.target.value})}/></div>
            <div><label className="label">To</label><Input type="date" value={reportDates.to} onChange={e=>setRD({...reportDates,to:e.target.value})}/></div>
            <button onClick={loadTab} className="btn-primary text-sm mb-0.5">Apply</button>
          </div>
          {reportData&&<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="card p-5 bg-green-50 border-green-200 border"><p className="text-xs text-green-600 font-semibold">TOTAL REVENUE</p><p className="text-2xl font-bold text-green-700">{fmt(reportData.revenue?.revenue||0)}</p><p className="text-xs text-green-500">{reportData.revenue?.count||0} studies</p></div>
            <div className="card p-5"><p className="text-xs text-slate-400">AVG TAT</p><p className="text-2xl font-bold">{parseFloat(reportData.tatCompliance?.avg_tat||0).toFixed(1)}h</p><p className="text-xs text-slate-400">Min: {parseFloat(reportData.tatCompliance?.min_tat||0).toFixed(1)}h / Max: {parseFloat(reportData.tatCompliance?.max_tat||0).toFixed(1)}h</p></div>
            <div className="card overflow-hidden">
              <div className="p-3 border-b"><h3 className="font-semibold text-sm text-slate-700">Scans by Modality</h3></div>
              <div className="divide-y max-h-48 overflow-y-auto">
                {(reportData.byModality||[]).map((r:any)=>(
                  <div key={r.modality} className="flex justify-between p-2 text-sm">
                    <span className="flex items-center gap-1"><span>{MODALITY_ICON[r.modality]||'🏥'}</span><span>{r.modality}</span></span>
                    <span className="font-bold">{r.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>}
        </div>
      )}

      

      {/* New Order Form */}
      {tab==='new_order'&&(
        <div className="max-w-3xl">
          <form onSubmit={submitOrder} className="space-y-3">
          <PatientSearchInput label="Patient *" selected={orderPatient} onSelect={(p:any)=>{setOrderPatient(p);setOrderForm(prev=>({...prev}));}} onClear={()=>setOrderPatient(null)}/>
          <div><label className="label">Service / Scan *</label>
            <input className="input mb-1 text-sm" placeholder="🔍 Search imaging service..." value={svcSearch} onChange={e=>setSvcSearch(e.target.value)}/>
            <Select value={orderForm.serviceId} onChange={e=>{const s=services.find((x:any)=>x.id===e.target.value);setOrderForm(prev=>({...prev,serviceId:e.target.value,modality:s?.modality||prev.modality,bodyPart:s?.bodyPart||prev.bodyPart,contrastRequired:s?.contrastRequired||false}));setSvcSearch('');}} required>
              <option value="">Select service</option>
              {MODALITIES.map(m=>{const filtered=services.filter((s:any)=>s.modality===m&&(!svcSearch||s.service_name||s.serviceName?.toLowerCase().includes(svcSearch.toLowerCase())));return filtered.length?[<option key={`h-${m}`} disabled value="">{MODALITY_ICON[m]||'🏥'} ── {m} ──</option>,...filtered.map((s:any)=><option key={s.id} value={s.id}>&nbsp;&nbsp;&nbsp;{s.service_name||s.serviceName} — {fmt(+s.base_price||s.basePrice+(+s.contrastPrice||0)+(+s.reportingPrice||0))}</option>)]:null;})}
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Priority *</label><Select value={orderForm.priority} onChange={e=>setOrderForm({...orderForm,priority:e.target.value})} required>{PRIORITIES.map(p=><option key={p}>{p}</option>)}</Select></div>
            <div><label className="label">Source</label><Select value={orderForm.source} onChange={e=>setOrderForm({...orderForm,source:e.target.value,admissionId:'',visitId:''})}>{['OPD','IPD','EMERGENCY','DIRECT'].map(s=><option key={s}>{s}</option>)}</Select></div>
            {orderForm.source==='IPD'&&(
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">Admission ID <span className="text-slate-300 font-normal normal-case">(required for IPD billing)</span></label>
                <input value={orderForm.admissionId} onChange={e=>setOrderForm({...orderForm,admissionId:e.target.value})}
                  placeholder="IPD Admission UUID" className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-[#02357A] focus:ring-2 focus:ring-[#02357A]/10 transition-all placeholder:text-slate-400"/>
              </div>
            )}
            {(orderForm.source==='OPD'||orderForm.source==='DIRECT')&&(
              <div style={{isolation:'isolate',position:'relative'}}>
                <PatientSearchInput label="Patient (OPD)" selected={null}
                  onSelect={(p:any)=>setOrderForm({...orderForm,patientId:p.id,visitId:p.id})}
                  onClear={()=>setOrderForm({...orderForm,patientId:'',visitId:''})}
                  placeholder="Search patient for OPD billing..."/>
              </div>
            )}
          </div>
          <div><label className="label">Clinical Notes / Indication</label><textarea className="input" rows={2} value={orderForm.clinicalNotes} onChange={e=>setOrderForm({...orderForm,clinicalNotes:e.target.value})} placeholder="Clinical history and reason for examination"/></div>
          {orderForm.serviceId&&services.find((s:any)=>s.id===orderForm.serviceId)?.preparationNotes&&<div className="bg-amber-50 border border-amber-200 rounded p-2 text-xs text-amber-700"><p className="font-semibold">Preparation Required:</p><p>{services.find((s:any)=>s.id===orderForm.serviceId)?.preparationNotes}</p></div>}
          {orderForm.contrastRequired&&<div className="bg-blue-50 border border-blue-200 rounded p-2 text-xs text-[#02357A]">💉 This service requires contrast — obtain patient consent before scan</div>}
          <div className="flex gap-3"><button type="submit" disabled={saving||!orderPatient||!orderForm.serviceId} className="btn-primary flex-1">{saving?'Creating...':'Create Radiology Order'}</button><button type="button" onClick={()=>setTab('orders')} className="btn-secondary">Cancel</button></div>
        </form>
        </div>
      )}

      {/* Service Form */}
      <SlidePanel isOpen={showSvcForm} onClose={()=>setShowSvcForm(false)} title="Add Radiology Service" size="md">
        <form onSubmit={submitSvc} className="grid grid-cols-2 gap-3">
          <div><label className="label">Service Code *</label><Input value={svcForm.serviceCode} onChange={e=>setSvcForm({...svcForm,serviceCode:e.target.value.toUpperCase()})} required/></div>
          <div><label className="label">Modality *</label><Select value={svcForm.modality} onChange={e=>setSvcForm({...svcForm,modality:e.target.value})} required>{MODALITIES.map(m=><option key={m}>{m}</option>)}</Select></div>
          <div className="col-span-2"><label className="label">Service Name *</label><Input value={svcForm.serviceName} onChange={e=>setSvcForm({...svcForm,serviceName:e.target.value})} required/></div>
          <div><label className="label">Body Part</label><Input value={svcForm.bodyPart} onChange={e=>setSvcForm({...svcForm,bodyPart:e.target.value})}/></div>
          <div><label className="label">Duration (min)</label><Input type="number" value={svcForm.standardDurationMinutes} onChange={e=>setSvcForm({...svcForm,standardDurationMinutes:e.target.value})}/></div>
          <div><label className="label">TAT (hours)</label><Input type="number" value={svcForm.tatHours} onChange={e=>setSvcForm({...svcForm,tatHours:e.target.value})}/></div>
          <div><label className="label">Base Price (₹)</label><Input type="number" value={svcForm.basePrice} onChange={e=>setSvcForm({...svcForm,basePrice:e.target.value})}/></div>
          <div><label className="label">Contrast Price (₹)</label><Input type="number" value={svcForm.contrastPrice} onChange={e=>setSvcForm({...svcForm,contrastPrice:e.target.value})}/></div>
          <div><label className="label">Reporting Price (₹)</label><Input type="number" value={svcForm.reportingPrice} onChange={e=>setSvcForm({...svcForm,reportingPrice:e.target.value})}/></div>
          <label className="flex items-center gap-2 text-sm col-span-2"><input type="checkbox" checked={svcForm.contrastRequired} onChange={e=>setSvcForm({...svcForm,contrastRequired:e.target.checked})} className="w-4 h-4"/><span>Contrast Required</span></label>
          <div className="col-span-2 flex gap-3"><button type="submit" disabled={saving} className="btn-primary flex-1">{saving?'Adding...':'Add Service'}</button><button type="button" onClick={()=>setShowSvcForm(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>

      {/* Template Form */}
      <SlidePanel isOpen={showTplForm} onClose={()=>setShowTplForm(false)} title="Add Report Template" size="lg">
        <form onSubmit={submitTpl} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Template Code *</label><Input value={tplForm.templateCode} onChange={e=>setTplForm({...tplForm,templateCode:e.target.value.toUpperCase()})} required/></div>
            <div><label className="label">Modality *</label><Select value={tplForm.modality} onChange={e=>setTplForm({...tplForm,modality:e.target.value})} required>{MODALITIES.map(m=><option key={m}>{m}</option>)}</Select></div>
            <div className="col-span-2"><label className="label">Template Name *</label><Input value={tplForm.templateName} onChange={e=>setTplForm({...tplForm,templateName:e.target.value})} required/></div>
            <div><label className="label">Body Part</label><Input value={tplForm.bodyPart} onChange={e=>setTplForm({...tplForm,bodyPart:e.target.value})}/></div>
          </div>
          <div><label className="label">Technique</label><textarea className="input text-xs" rows={2} value={tplForm.techniqueTemplate} onChange={e=>setTplForm({...tplForm,techniqueTemplate:e.target.value})}/></div>
          <div><label className="label">Findings Template</label><textarea className="input text-xs font-mono" rows={5} value={tplForm.findingsTemplate} onChange={e=>setTplForm({...tplForm,findingsTemplate:e.target.value})} placeholder="Default normal findings text..."/></div>
          <div><label className="label">Impression Template</label><textarea className="input" rows={2} value={tplForm.impressionTemplate} onChange={e=>setTplForm({...tplForm,impressionTemplate:e.target.value})}/></div>
          <div className="flex gap-3"><button type="submit" disabled={saving} className="btn-primary flex-1">{saving?'Adding...':'Add Template'}</button><button type="button" onClick={()=>setShowTplForm(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>
    </Layout>
  );
}
